import React from 'react'
import styled from 'styled-components'
import logoTF1 from '../../../assets/logo-tf1.png'
import logoFrance2 from '../../../assets/logo-france-2.svg'
import logoCapital from '../../../assets/logo-capital.svg'
import logoLeFigaro from '../../../assets/logo-le-figaro.svg'
import logoM6 from '../../../assets/logo-m6.svg'
import logoLeMonde from '../../../assets/logo-le-monde.svg'
import logoBFMTV from '../../../assets/logo-bfm-tv.png'
import logoEurope1 from '../../../assets/logo-europe-1.svg'

const PresseContainerFullWidth = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 32px;
  background-color: #fff;

  h1 {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #253163;
    margin: 0;
  }
`

const LogosContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 32px;
  row-gap: 24px;
  padding: 16px;
`

export const Presse = () => (
  <PresseContainerFullWidth>
    <h1>La presse parle de nous:</h1>
    <LogosContainer>
      <img src={logoTF1} height={20} alt="logo TF1" />
      <img src={logoFrance2} height={12} alt="logo France 2" />
      <img src={logoCapital} height={18} alt="logo Capital" />
      <img src={logoLeFigaro} height={18} alt="logo Le Figaro" />
      <img src={logoM6} height={26} alt="logo M6" />
      <img src={logoLeMonde} height={18} alt="logo Le Monde" />
      <img src={logoBFMTV} height={26} alt="logo BFM TV" />
      <img src={logoEurope1} height={20} alt="logo Europe 1" />
    </LogosContainer>
  </PresseContainerFullWidth>
)
